var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-2"},[_c('div',{staticClass:"overflow-hidden text-center"},[_c('span',{staticClass:"home__section-title text-uppercase font-weight-medium"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }